import React from "react"
import './UploadPopup.css'
import FileIcon from "../../../assets/icons/file-icon.svg";
import FolderIcon from "../../../assets/icons/folder-icon.svg";
import {Upload} from "antd";

const Popup = ({record, visible, x, y, onFileSelected, onFolderSelected, intl, onMouseLeave, onMouseEnter}) => visible &&
  <ul 
    className="upload-popup" 
    style={{position: "absolute", left: `${x}px`, top: `${y}px`}}
    onMouseLeave = {onMouseLeave}
    onMouseEnter = {onMouseEnter}
>
    <li>
      <Upload
        name='dropdown_files'
        multiple
        showUploadList= {false}
        beforeUpload={() => {
          return false;
        }}
        onChange={onFileSelected}
      >
        <div className="upload-item">
          <img src={FileIcon} alt="file" style = {{marginRight: 10, fill: "black"}}/>
          {intl.formatMessage({id: "upload-folder-dragzone-select-files"})}
        </div>
      </Upload>
    </li>
    <li>
      <Upload
          name='dropdown_folder'
          multiple
          directory
          showUploadList= {false}
          beforeUpload={() => {
            return false;
          }}
          onChange={onFolderSelected}
        >
          <div className="upload-item">
            <img src={FolderIcon} alt="folder" style = {{marginRight: 10, fill: "black"}}/>
            {intl.formatMessage({id: "upload-folder-dragzone-select-folders"})}
          </div>
        </Upload>
    </li>
  </ul>

export default Popup